import * as ActionTypes from '../actions/types';
import xs from 'xstream';
import {BASE_URL} from "../helpers/constants";
import * as actions from "../actions/index";
import sampleCombine from 'xstream/extra/sampleCombine';
import { push } from 'react-router-redux'

export function redirectAfterDelete(sources) {
  const action$ = sources.ACTION
    .filter(action => action.type === ActionTypes.DELETE_SCORE_RECORD_SUCCESS)
    .map(action => (push('/score-records')));

  return {
    ACTION: action$
  }
}

export function requestDeleteScoreRecord(sources) {

  const state$ = sources.STATE;
  const token$ = state$.map(state => state.loggedInPerson.get('token'));

  const request$ = sources.ACTION
    .filter(action => action.type === ActionTypes.DELETE_SCORE_RECORD)
    .compose(sampleCombine(token$))
    .map( ([action, token]) => ({
      url: BASE_URL + 'api/scoreRecordCards/' + action.payload.id,
      category: 'requestDeleteScoreRecord',
      method: 'DELETE',
      headers: {Authorization: token},
    }));

  let httpResponse$ = sources.HTTP
    .select('requestDeleteScoreRecord')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status === 204)
    .map(response => actions.deleteScoreRecordSuccess(response));

  return {
    ACTION: httpResponse$,
    HTTP: request$
  }
}

export function requestDeleteScoreRecordFailed(sources) {
  let httpResponse$ = sources.HTTP
    .select('requestDeleteScoreRecord')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status !== 204)
    .map(response => actions.deleteScoreRecordFailed(response));

  return {
    ACTION: httpResponse$
  }
}

export function requestCreateScoreRecordFormFile(sources) {

  const state$ = sources.STATE;
  const token$ = state$.map(state => state.loggedInPerson.get('token'));

  const request$ = sources.ACTION
    .filter(action => action.type === ActionTypes.CREATE_SCORE_RECORD_FROM_FILE)
    .compose(sampleCombine(token$))
    .map( ([action, token]) => ({
      url: BASE_URL + 'api/scoreRecordCards/file',
      category: 'requestCreateScoreRecordFormFile',
      method: 'POST',
      send : action.payload.sendBody,
      headers: {Authorization: token},
    }));

  let httpResponse$ = sources.HTTP
    .select('requestCreateScoreRecordFormFile')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status === 200)
    .map(response => actions.createScoreRecordFromFileSuccess(response));

  return {
    ACTION: httpResponse$,
    HTTP: request$
  }
}

export function requestCreateScoreRecordFormFileFailed(sources) {
  let httpResponse$ = sources.HTTP
    .select('requestCreateScoreRecordFormFile')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status !== 200)
    .map(response => actions.createScoreRecordFromFileFailed(response));

  return {
    ACTION: httpResponse$
  }
}

export function requestUpdateScoreRecord(sources) {

  const state$ = sources.STATE;
  const token$ = state$.map(state => state.loggedInPerson.get('token'));

  const request$ = sources.ACTION
    .filter(action => action.type === ActionTypes.UPDATE_SCORE_RECORD)
    .compose(sampleCombine(token$))
    .map( ([action, token]) => ({
      url: BASE_URL + 'api/scoreRecordCards',
      category: 'requestUpdateScoreRecord',
      method: 'PATCH',
      send: action.payload.sendBody,
      headers: {Authorization: token},
    }));

  let httpResponse$ = sources.HTTP
    .select('requestUpdateScoreRecord')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status === 200)
    .map(response => actions.updateScoreRecordSuccess(response));

  return {
    ACTION: httpResponse$,
    HTTP: request$
  }
}

export function requestUpdateScoreRecordFailed(sources) {
  let httpResponse$ = sources.HTTP
    .select('requestUpdateScoreRecord')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status !== 200)
    .map(response => actions.updateScoreRecordFailed(response));

  return {
    ACTION: httpResponse$
  }
}

export function requestScoreRecordById(sources) {

  const state$ = sources.STATE;
  const token$ = state$.map(state => state.loggedInPerson.get('token'));

  const request$ = sources.ACTION
    .filter(action => action.type === ActionTypes.GET_SCORE_RECORD_BY_ID)
    .compose(sampleCombine(token$))
    .map( ([action, token]) => ({
      url: BASE_URL + 'api/scoreRecordCards/' + action.payload.id +
        (action.payload.filter?`?filter=${JSON.stringify(action.payload.filter)}`:''),
      category: 'requestScoreRecordById',
      method: 'GET',
      headers: {Authorization: token},
    }));

  let httpResponse$ = sources.HTTP
    .select('requestScoreRecordById')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status === 200)
    .map(response => actions.getScoreRecordByIdSuccess(response));

  return {
    ACTION: httpResponse$,
    HTTP: request$
  }
}

export function requestScoreRecordByIdFailed(sources) {
  let httpResponse$ = sources.HTTP
    .select('requestScoreRecordById')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status !== 200)
    .map(response => actions.getScoreRecordByIdFailed(response));

  return {
    ACTION: httpResponse$
  }
}


export function redirectAfterCreateStoreRecordSuccess(sources) {
  const action$ = sources.ACTION
    .filter(action => action.type === ActionTypes.CREATE_SCORE_RECORD_SUCCESS)
    .map(action => push('/score-records'));

  return {
    ACTION: action$,
  }
}


export function requestCreateScoreRecord(sources) {

  const state$ = sources.STATE;
  const token$ = state$.map(state => state.loggedInPerson.get('token'));

  const request$ = sources.ACTION
    .filter(action => action.type === ActionTypes.CREATE_SCORE_RECORD)
    .compose(sampleCombine(token$))
    .map( ([action, token]) => ({
      url: BASE_URL + 'api/scoreRecordCards',
      category: 'requestCreateScoreRecord',
      method: 'POST',
      send: action.payload.sendBody,
      headers: {Authorization: token},
    }));

  let httpResponse$ = sources.HTTP
    .select('requestCreateScoreRecord')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status === 200)
    .map(response => actions.createScoreRecordSuccess(response));

  return {
    ACTION: httpResponse$,
    HTTP: request$
  }
}

export function requestCreateScoreRecordFailed(sources) {
  let httpResponse$ = sources.HTTP
    .select('requestCreateScoreRecord')
    .map((response) =>
      response.replaceError((err) => xs.of(err))
    )
    .flatten()
    .filter(response => response.status !== 200)
    .map(response => actions.createScoreRecordFailed(response));

  return {
    ACTION: httpResponse$
  }
}



// WEBPACK FOOTER //
// ./src/cycles/scoreRecord.js